import { isMotionValue } from 'motion-dom';

function isWillChangeMotionValue(value) {
    return Boolean(isMotionValue(value) && value.add);
}

export { isWillChangeMotionValue };
//# sourceMappingURL=is.mjs.map
